<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { Primitive, type PrimitiveProps } from "radix-vue"
import { useClass } from "~/composables/local/cn-class"
import { type ButtonVariants, buttonVariants } from "."

type Props = {
	variant?: ButtonVariants["variant"]
	size?: ButtonVariants["size"]
	class?: HTMLAttributes["class"]
} & PrimitiveProps

const { as = "button", ...props } = defineProps<Props>()

const varentClass = computed(() => buttonVariants({ variant: props.variant, size: props.size }))

const className = useClass(
	varentClass,
	() => props.class,
)
</script>

<template>
	<Primitive
		:as="as"
		:as-child="asChild"
		:class="className">
		<slot />
	</Primitive>
</template>
